import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { cookieStorageService } from '@/shared/services/cookieStorageService';
import { localStorageService } from '@/shared/services/localStorageService';
import { getMenuFromCache } from '@/hooks/autenticacion/getMenuFromCache';

// Query Keys
export const autenticacionKeys = {
  all: ['autenticacion'] as const,
  menu: () => [...autenticacionKeys.all, 'menu'] as const,
};

// ==========================================
// QUERIES
// ==========================================

// Hook para obtener el menú completo (con cache de TanStack Query + localStorage TTL)
// Los componentes que lo usan deben filtrar según necesiten (Menu vs Cards)
export function useMenuQuery() {
  const query = useQuery({
    queryKey: autenticacionKeys.menu(),
    queryFn: () => getMenuFromCache(),
    staleTime: 1000 * 60 * 30, // 30 minutos
    gcTime: 1000 * 60 * 60, // 1 hora en memoria
    enabled: !!cookieStorageService.getItem('accessToken'),
  });

  // Sincronizar con localStorage para useValidarAccesoMenu
  // Este efecto se ejecuta cuando los datos cambian, no en el queryFn
  useEffect(() => {
    if (query.data && query.data.length > 0) {
      localStorageService.setItem('menu', JSON.stringify(query.data));
    }
  }, [query.data]);

  return query;
}
